export default __webpack_public_path__ + "static/media/network.91524aef.svg";